<template>
  <ModalConfirm :open="open" @update:open="updateOpen"
                @confirm="createSupportRequest"
                :close-on-confirm="false"
                title="New Support Request"
                level="info" description=""
                :loading="loading"
                proceed-button-text="Submit Request"
                class="z-max">
    <Component :is="component" v-model:data="data" :meta="meta" />
  </ModalConfirm>
</template>

<script setup>
import ModalConfirm from "./ModalConfirm.vue";
import SupportRequestApi from "../api/SupportRequestApi.js";
import SupportRequestTypeJobTitle from "./SupportRequestTypeJobTitle.vue";
import {ref} from "vue";

const emits = defineEmits(["update:open"]);
const props = defineProps({
  open: Boolean,
  type: String,
  meta: Object,
});

const data = ref([]);
const loading = ref(false);

const updateOpen = (isOpen) => emits("update:open", isOpen);

const componentMap = {
  job_title: SupportRequestTypeJobTitle,
};

const component = componentMap[props.type];

const createSupportRequest = async () => {
  loading.value = true;
  const api = new SupportRequestApi();

  try {
    await api.create({
      type: props.type,
      data: data.value,
    });

    toast.success("Your support request has been created.");
    updateOpen(false);
  } catch (e) {
    console.error(e);
  } finally {
    loading.value = false;
  }
};
</script>
